
import React from 'react';
import './sma-slope-badge.css';

const ARROWS = { up: '↑', down: '↓', flat: '→' };

function SlopeArrow({ label, slope }) {
  if (!slope || slope === 'flat') {
    return (
      <span className="sma-slope-item sma-slope-flat" title={`${label}: flat`}>
        {label}{ARROWS.flat}
      </span>
    );
  }
  return (
    <span className={`sma-slope-item sma-slope-${slope}`} title={`${label}: ${slope}`}>
      {label}{ARROWS[slope]}
    </span>
  );
}

function SmaSlopeBadge({ weekly, daily, fourHour }) {
  if (!weekly && !daily && !fourHour) {
    return <span className="sma-slope-na">N/A</span>;
  }

  return (
    <div className="sma-slope-badge">
      <SlopeArrow label="W" slope={weekly} />
      <SlopeArrow label="D" slope={daily} />
      <SlopeArrow label="4H" slope={fourHour} />
    </div>
  );
}

export default SmaSlopeBadge;
